import ComplianceNavigatorBaseTable from "./ComplianceNavigatorBaseTable";
import useColumn from "../../../utils/customHooks/useColumns";
import usePageState from "../../../utils/customHooks/usePageState";
import { useCallback, useEffect, useState } from "react";
import {
  COMPLIANCE_DOCUMENT_DETAIL_SUMMARIES,
  GET_ALL_COMPLIANCE_INSIGHT_DATA,
  GET_ALL_COMPLIANCE_TABLE,
  GET_ALL_COMPLIANCE_TABLE_DATA
} from "../../../utils/services/apiPath";
import { getApi, postApi } from "../../../utils/services";
import ComplianceNavigatorActionButtons from "./ComplianceNavigatorActionButtons";
import PropTypes from "prop-types";
import UploadFieldsData from "./UploadFieldsData";
import { errorToast } from "../../../utils/toastHelper";
import { v4 as uuidV4 } from "uuid";
import { createODataQuery } from "../../../utils/services/oData";
import { IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { handleDownload } from "../../../utils/fileDownload";
import UploadFileSixSevenOneForm from "./UploadFileSixSevenOneForm";
import { useSelector } from "react-redux";
import { subModPermissionSelector } from "../../store/features/permissions/permissionsSlice";
import { R_ALL_DOCUMENTS, R_DOCUMENTS_671_FORM } from "../../../utils/permissionReferenceConfig";

const SixSevenOneTable = ({ tableKey, projectId, partnerId }) => {
  const {
    currentPage,
    pageSize,
    data: tableData,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();

  const { canExport: canExport671 } = useSelector(subModPermissionSelector(R_ALL_DOCUMENTS, R_DOCUMENTS_671_FORM));

  const columns = useColumn([
    {
      field: "projectName",
      headerName: "Project Name"
    },
    {
      field: "partnerName",
      headerName: "Partner Name"
    },
    {
      field: "apprenticeName",
      headerName: "Apprentice Name"
    },
    {
      field: "jobTitle",
      headerName: "Labor Classification Title"
    },
    {
      field: "sponsorName",
      headerName: "Sponsor"
    },
    {
      field: "documentKey",
      headerName: "Actions",
      width: 160,
      renderCell: params => (
        <>
          {canExport671 && (
            <IconButton onClick={() => handleDownload(params.row.mediaDetails?.path)} color="primary">
              <FileDownloadIcon fontSize="small" />
            </IconButton>
          )}
        </>
      )
    }
  ], true);

  const [insightData, setInsightData] = useState();

  const fetchInsightData = async () => {
    const res = await getApi(`${COMPLIANCE_DOCUMENT_DETAIL_SUMMARIES}?key=${tableKey}&projectId=${projectId}&partnerId=${partnerId}`);
    setInsightData(res);
  };

  useEffect(() => {
    if (tableKey && partnerId && projectId) {
      fetchInsightData();
    }
  }, [projectId, partnerId, tableKey]);

  const handleSave = (file, handleClose) => {
    console.log(file);
    handleClose();
  };

  const getTableData = useCallback(async () => {
    const payload = {
      pageIndex: currentPage + 1,
      pageSize: pageSize,
      orderByAscending: sortModel.orderByAscending || true,
      searchString: searchString || "",
      orderCol: sortModel.orderCol || ""
    };
    const searchableFields = ["partnerName", "projectName", "jobTitle", "sponsorName", "apprenticeName"];
    const { data, totalRecords, error } = await getApi(
      `${
        GET_ALL_COMPLIANCE_TABLE + createODataQuery(searchableFields, [], "", searchString, sortModel, pageSize, currentPage)
      }&key=${tableKey}&projectId=${projectId}&partnerId=${partnerId}`,
      payload
    );

    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data?.map(row => ({ ...row, id: uuidV4() })) || [] || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  useEffect(() => {
    getTableData();
  }, [getTableData]);

  return (
    <ComplianceNavigatorBaseTable
      columns={columns}
      title="Form 671"
      rows={tableData}
      insightData={insightData}
      tableKey={tableKey}
      rowCount={rowCount}
      status={status}
      setPagination={setPagination}
      setSortModel={setSortModel}
      searchString={searchString}
      setSearchString={setSearchString}
      getRowId={row => row.id}
      pageSize={pageSize}
      currentPage={currentPage}
      uploadPopUp={<UploadFileSixSevenOneForm  title="671 - File Upload" getDetailData={getTableData} fetchInsightData={fetchInsightData}/>}
    />
  );
};

SixSevenOneTable.propTypes = {
  tableKey: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  partnerId: PropTypes.string.isRequired
};

export default SixSevenOneTable;
